module.exports = __webpack_public_path__ + "assets/img/32t.affa0f3b.png";